<template>
  <styled-multiselect
    v-model="selectedSupplier"
    :is-error="isError"
    :label="label"
    :loading="isFetchingSuppliers"
    :options="suppliers"
    :placeholder="$t('projectSuppliersSelect.selectSupplier')"
    :track-by="trackBy"
  ></styled-multiselect>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import StyledMultiselect from '../StyledMultiselect/StyledMultiselect.vue';
  import { SuppliersService } from '@/services';
  import { GlobalUtils } from '@/mixins/globalUtils';

  export type SupplierOption = {
    name: string;
    _id: string;
    SAPNumber: string;
  };

  export default defineComponent({
    name: 'ProjectSuppliersSelect',
    components: { StyledMultiselect },
    props: {
      isError: {
        type: Boolean,
        default: false,
      },
      projectId: {
        type: String,
        required: true,
      },
      modelValue: {
        type: Object as () => SupplierOption | null,
        default: null,
      },
    },
    emits: ['update:modelValue'],
    data(): {
      isFetchingSuppliers: boolean;
      selectedSupplier: SupplierOption | null;
      suppliers: SupplierOption[];
    } {
      return {
        isFetchingSuppliers: false,
        selectedSupplier: null,
        suppliers: [],
      };
    },
    computed: {
      label(): keyof SupplierOption {
        return 'name';
      },
      trackBy(): keyof SupplierOption {
        return 'name';
      },
    },
    watch: {
      modelValue(newValue) {
        this.selectedSupplier = newValue;
      },
      selectedSupplier(newValue) {
        this.$emit('update:modelValue', newValue);
      },
    },
    mounted() {
      this.fetchSuppliers();
    },
    methods: {
      async fetchSuppliers() {
        this.isFetchingSuppliers = true;
        try {
          this.suppliers = await SuppliersService.getSuppliersForProject(
            this.projectId,
            ['_id', 'name', 'SAPNumber'],
          );
        } catch {
          (this as unknown as GlobalUtils).createErrorToast(
            this.$t('projectSuppliersSelect.errors.errorGettingSuppliers'),
          );
        }

        this.isFetchingSuppliers = false;
      },
    },
  });
</script>
